<template>
  <div>
    <div class="h-dialogContainer" >
      <template>
        <ParseForm ref="basic" :formId="formItems.basic.formId" :formParams="formItems.basic.formObj" :opCode="opCode" :funcClick="bindClickInterface"></ParseForm>
      </template>
    </div>
  </div>
</template>

<script>
import ParseForm from '../../../util/parseFormNew/ParseForm';
import SubscriberTool from '../../../util/parseFormNew/tools/subscriberTool';
import ajaxUrl from "../../../data/ajaxUrl";
import { EventBus } from '../../../../../plugins/eventBus';

export default {
  name: "AddPuiForm",
  components: {
    ParseForm,
  }, 
  methods: {
    getDatas() {
      const map = new Map();
      if (this.$refs.basic) {
        if (!this.$refs.basic.validateResult()) {
          console.log("表单验证不通过");
          return;
        }
        const maps = this.$refs.basic.getDatas();
        for (const [key, value] of maps.entries()) {
          map.set(key, value);
        }
      }
      console.log(map);
      return map;
    },
     getJson(ne, callback) {
      this.ne = ne;
      const params = {
        msgid: this.msgId,
        neid: ne.neid,
      };
      this.$axios.post(ajaxUrl.addpuiJsonReq, params).then(response => {//假数据
      console.log("response",response)
        if (!response) {
          console.log("getJson response error");
          return;
        }
        if (!response.data) {
          console.log("getJson response.data error");
          return;
        }
        if (!response.data.resultVal) {
          console.log("getJson response.data.resultVal error");
          return;
        }
        if (response.data.errorCode !== "0") {
          console.log("getJson response.data.errorCode error");
          callback(response);
          return;
        }
        const jsonObj = response.data.resultVal;
        const sub = new SubscriberTool();
        const resultMap = sub.$devideByGroupBy(jsonObj, []);
        this.formItems.basic.formObj = resultMap.get(this.formItems.basic.modelName);
        callback(response);
      }); 
    }, 
    saveUser(ne, callback) {
      const formData = this.getDatas();      
      if (formData) { 
        const cfuStatus=formData.get("cfuStatus");
        const cfuPui=formData.get("cfuPui");
        const cfbStatus=formData.get("cfbStatus");
        const cfbPui=formData.get("cfbPui");
        const cfnrStatus=formData.get("cfnrStatus");
        const cfnrPui=formData.get("cfnrPui");
        const cfnlStatus=formData.get("cfnlStatus");
        const cfnlPui=formData.get("cfnlPui");
        if((cfuStatus==1||cfuStatus==2)&&cfuPui==""){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("Pui.cfuPuiNull")});
            return false
        }
        if((cfbStatus==1||cfbStatus==2)&&cfbPui==""){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("Pui.cfbPuiNull")});
            return false
        }
        if((cfnrStatus==1||cfnrStatus==2)&&cfnrPui==""){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("Pui.cfnrPuiNull")});
            return false
        }
        if((cfnlStatus==1||cfnlStatus==2)&&cfnlPui==""){
            EventBus.$emit('toast', {type: 'warning', content: this.$t("Pui.cfnlPuiNull")});
            return false
        }

        const params = { 
          vo: {
            "pui": formData.get("pui"),
            "pvi": formData.get("pvi"),
            "oipStatus": formData.get("oipStatus"),
            "oipOverride": formData.get("oipOverride"),
            "oirStatus": formData.get("oirStatus"),
            "oirMode": formData.get("oirMode"),
            "oirTemporarySet": formData.get("oirTemporarySet"),
            "oirRestrictMode": formData.get("oirRestrictMode"),
            "cfuStatus": formData.get("cfuStatus"),
            "cfuPui": formData.get("cfuPui"),
            "cfbStatus": formData.get("cfbStatus"),
            "cfbPui": formData.get("cfbPui"),
            "cfnrStatus": formData.get("cfnrStatus"),
            "cfnrPui": formData.get("cfnrPui"),
            "cfnrTime": parseInt(formData.get("cfnrTime")),
            "cfnlStatus": formData.get("cfnlStatus"),
            "cfnlPui": formData.get("cfnlPui"),
            "cfnrcStatus": formData.get("cfnrcStatus"),
            "cfnrcPui": formData.get("cfnrcPui"),
            "cwStatus": formData.get("cwStatus"),
            "cwNotify": formData.get("cwNotify"),
            "holdStatus": formData.get("holdStatus"),
            "ocbStatus": formData.get("ocbStatus"),
            "icbStatus": formData.get("icbStatus"),
            "thirdPartyStatus": formData.get("thirdPartyStatus"),
            "confStatus": formData.get("confStatus"),
             }, 
          info: {
            msgid: this.msgId,
            neid: ne.neid,
          }
        };
        this.$axios.post(ajaxUrl.requestCommonD, params).then((response) => {
          if (callback) {
            callback(response);
          }
        });
      } 
    }, 
  },
  computed: {

  },
  data() {
    return {
      ne: null, 
      formItems: {
        basic: {
          formId: "PuiAddBasicInfo",
          modelName: "basic",
          formObj: null,
        },
      }, 
      opCode: "add",
      msgId: "30480",
    };
  },
  beforeDestroy() {
  }
};
</script>
